module.exports = __webpack_public_path__ + "assets/pdf/handbook-en.37ccc9b9.epub";